// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"j9phuI","container":"vAEZnY"};